import React, {ReactNode} from "react";


import {
    Col, Row
} from "react-bootstrap";


import "./index.scss";


type CardContentComponentProps = {
    children: ReactNode | ReactNode[];
    className?: string;
    xs?: 'auto' | number; lg?: 'auto' | number;
};


export const CardContentComponent:React.FC<CardContentComponentProps> = ({
    children, className = 'orientation-vertical',
    xs = 'auto', lg = 12
}) => {

    if (!children) {
        return null;
    }

    return (
        <Col xs={xs} lg={lg} className={`card-content-component ${className}`}>
            <Row className={`card-content-component__content`}>
                {children}
            </Row>
        </Col>
    )

};


export default CardContentComponent;
